import { isEmpty, isNil, get, has } from 'lodash';

export default {
  data() {
    return {
      shareLevelKeys: {
        1: 'common.card.share_level.public',
        2: 'common.card.share_level.private',
      },
    };
  },

  methods: {
    getCoreConceptLabel(coreConcept) {
      if (isNil(coreConcept) || isEmpty(coreConcept)) {
        return null;
      }

      return `${coreConcept.name} ${coreConcept.position}`;
    },

    getDetailedCoreConceptLabel(coreConcept) {
      if (isNil(coreConcept) || isEmpty(coreConcept)) {
        return null;
      }

      return `${coreConcept.name} (${coreConcept.description})`;
    },

    getUnitLabel(unit) {
      if (isNil(unit) || isEmpty(unit)) {
        return null;
      }

      return unit.name;
    },

    getDomainLabel(domain) {
      if (isNil(domain) || isEmpty(domain)) {
        return null;
      }

      return domain.name;
    },

    getShareLevelLabel(shareLevel) {
      if (shareLevel === 1 || shareLevel === 2) {
        return this.$t(this.shareLevelKeys[shareLevel]);
      }

      return '-';
    },

    getSchoolYear(item) {
      return get(item, 'school_year', 0);
    },

    getName(item) {
      return get(item, 'name');
    },

    getTranslatedName(item) {
      if (has(item, 'id')) {
        return this.getName(item);
      }

      return this.$t(this.getName(item));
    },
  },
};
